jQuery(function ($) {
  if ($(".formations-form").length) {
    // Open
    $(".formations-form .domaine").each(function () {
      $(this).on("click", function () {
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
        } else if (!$(this).hasClass("disabled")) {
          $(".domaine").removeClass("open");
          $(this).addClass("open");
        }
      }); 
    });
  }
});
